import { wrapWithColorGenerator } from "./color-generator-wrap.js";
import { DefaultVisualModel } from "./default-visual-model.js";
import { createDefaultEntityModel } from "./entity-model/default-entity-model.js";
import { MODEL_VISUAL_TYPE } from "./visual-entity.js";
class DefaultVisualModelFactory {
    createNewWritableVisualModelSync() {
        const identifier = createIdentifier();
        const internal = createDefaultEntityModel(MODEL_VISUAL_TYPE, identifier);
        return this.createWritableVisualModelSync(internal);
    }
    createWritableVisualModelSync(model) {
        return wrapWithColorGenerator(new DefaultVisualModel(model));
    }
    createWritableVisualModelSyncNoWrap(model) {
        return new DefaultVisualModel(model);
    }
}
const createIdentifier = () => (Math.random() + 1).toString(36).substring(7);
const factory = new DefaultVisualModelFactory();
export function createDefaultVisualModelFactory() {
    return factory;
}
//# sourceMappingURL=visual-model-factory.js.map